<template>
  <div>
    <b-modal
        :title="$t('Change password')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        no-close-on-backdrop>
      <ValidationObserver ref="form" tag="form" @submit.prevent="save()">
        <b-form-group>
          <ValidationProvider rules="required" v-slot="{ errors }">
            <b-input-group class="input-group-trans">
              <b-form-input type="password" v-model="formData.currentPassword" ref="txtPassword"
                            :placeholder="$t('Current password')"
                            :disabled="loading"/>
              <b-input-group-append>
                <b-input-group-text>
                  <img src="images/ico-lock.png"/>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <div class="validate-error">{{ errors[0] }}</div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group>
          <ValidationProvider rules="required" v-slot="{ errors }" vid="newPassword">
            <b-input-group class="input-group-trans">
              <b-form-input type="password" v-model="formData.newPassword" :placeholder="$t('New password')"
                            :disabled="loading"/>
              <b-input-group-append>
                <b-input-group-text>
                  <img src="images/ico-lock.png"/>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <div class="validate-error">{{ errors[0] }}</div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group>
          <ValidationProvider rules="required|confirmed:newPassword" v-slot="{ errors }">
            <b-input-group class="input-group-trans">
              <b-form-input type="password" v-model="formData.rePassword" :placeholder="$t('Confirm password')"
                            :disabled="loading"/>
              <b-input-group-append>
                <b-input-group-text>
                  <img src="images/ico-lock.png"/>
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <div class="validate-error">{{ errors[0] }}</div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group class="mb-0">
          <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">
            {{
              $t("Save changes")
            }}
          </b-button>
        </b-form-group>
      </ValidationObserver>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
  </div>
</template>

<script>
import authenticateService from "../services/authenticate_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "ChangePasswordModal",
  data: function () {
    return {
      loading: false,
      show: false,
      formData: {
        currentPassword: "",
        newPassword: "",
        rePassword: ""
      }
    }
  },
  methods: {
    async save() {
      if ((await this.$refs.form.validate()) != true)
        return;



      if (this.loading == true)
        return;

      this.loading = true;
      const response = await authenticateService.changePassword(this.formData);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      dialogHelper.alert(response.substr(3), "success");
      this.show = false;
    },
    open() {
      this.formData = {
        currentPassword: "",
        newPassword: "",
        rePassword: ""
      };

      this.show = true;
    }
  }
}
</script>

<style scoped>

</style>